import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/api/apiClient';
import { useSessionStore } from '@/entities/session';

export interface InvoiceHistoryItem {
  invoiceId: string;
  invoiceNum: string;
  date: string;
  amount: number;
  currencyCode: string;
  bankKey: string;
}

export type InvoiceHistoryResponse = InvoiceHistoryItem[];

export const useInvoiceHistory = () => {
  const { session } = useSessionStore();

  return useQuery({
    queryKey: ['invoice-history', session?.userId],
    queryFn: async (): Promise<InvoiceHistoryResponse> => {
      const response = await apiClient.get('/operations/bank/deposit/invoices');
      return response.data;
    },
    staleTime: 10000,
  });
};
